import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import s from './StepIndicator.module.scss';

type Props = {
  step: number;
  total: number;
  label?: string;
  className?: string;
};

type Ref = HTMLDivElement;

const StepIndicator = forwardRef<Ref, Props>(
  ({ step, total, label, className }, ref) => {
    const barWidth = (1 / total) * 100;
    const barOffset = ((step - 1) / total) * 100;

    interface StepBarStyle {
      left: string;
      width?: string;
      right?: string;
    }

    const stepBarStyle: StepBarStyle = {
      width: `${barWidth}%`,
      left: `${barOffset}%`,
    };
    if (step === total) {
      stepBarStyle.right = '0';
      delete stepBarStyle.width;
    }
    return (
      <div
        className={`${s.stepIndicator} ${className}`}
        tabIndex={-1}
        ref={ref}
      >
        <FormattedMessage id="stepindicator.step" /> {step}/{total}
        <div
          className={s.fullwidthbar}
        />: <div className={s.stepbar} style={stepBarStyle} />
        {label}
      </div>
    );
  }
);

StepIndicator.defaultProps = {
  className: '',
  label: '',
};

StepIndicator.propTypes = {
  step: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  label: PropTypes.string,
  /** Classes to apply to wrapping div */
  className: PropTypes.string,
};

export default StepIndicator;
